import { render, staticRenderFns } from "./set_power2.vue?vue&type=template&id=6617dfaa&scoped=true"
import script from "./set_power2.vue?vue&type=script&lang=js"
export * from "./set_power2.vue?vue&type=script&lang=js"
import style0 from "./set_power2.vue?vue&type=style&index=0&id=6617dfaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617dfaa",
  null
  
)

export default component.exports